import logoTrustedShop from 'views/assets/images/logos/logo-trusted.svg'
import logoTuv from 'views/assets/images/logos/logo-tuv.svg'
import logoDownload from 'views/assets/images/logos/logo-download.svg'
import logoAppstore from 'views/assets/images/logos/logo-appstore.svg'
import logoGoogleplay from 'views/assets/images/logos/logo-google-play.svg'
import logoAppstoreIt from 'views/assets/images/logos/logo-appstore-it.svg'
import logoGoogleplayIt from 'views/assets/images/logos/logo-google-play-it.svg'
import logoAppstoreFr from 'views/assets/images/logos/logo-appstore-fr.svg'
import logoGoogleplayFr from 'views/assets/images/logos/logo-google-play-fr.svg'
import logoWebshopAward from 'views/assets/images/logos/logo-webshop-award.svg'
import logoInsegniaItalia from 'views/assets/images/logos/logo-insegnia-Italia.svg'
import logoCapitalHorizontalFR from 'views/assets/images/logos/logo-capital-fr-horizontal.png'
import logoVSVCH from 'views/assets/images/logos/logo-vsv-ch.png'
import logoEaep from 'views/assets/images/logos/logo-eaep.svg'

import { LOGO_APPLE_STORE, LOGO_GOOGLE_STORE } from 'shared/consts/appLogos'

import {
  TENANT_COM,
  TENANT_AT,
  TENANT_IT,
  TENANT_FR
} from 'shared/consts/tenants'

export const LOGOS = {
  trustedshops: logoTrustedShop,
  tuv: logoTuv,
  eaep: logoEaep,
  download: logoDownload,
  webshopaward: logoWebshopAward,
  insegniaItalia: logoInsegniaItalia,
  capital: logoCapitalHorizontalFR,
  vsv: logoVSVCH
}

export const APP_LOGOS_MAP = {
  [TENANT_COM]: {
    [LOGO_APPLE_STORE]: { src: logoAppstore, width: 135, height: 40 },
    [LOGO_GOOGLE_STORE]: { src: logoGoogleplay, width: 135, height: 40 }
  },
  [TENANT_AT]: {
    [LOGO_APPLE_STORE]: { src: logoAppstore, width: 135, height: 40 },
    [LOGO_GOOGLE_STORE]: { src: logoGoogleplay, width: 135, height: 40 }
  },
  [TENANT_IT]: {
    [LOGO_APPLE_STORE]: { src: logoAppstoreIt, width: 120, height: 40 },
    [LOGO_GOOGLE_STORE]: { src: logoGoogleplayIt, width: 135, height: 40 }
  },
  [TENANT_FR]: {
    [LOGO_APPLE_STORE]: { src: logoAppstoreFr, width: 127, height: 40 },
    [LOGO_GOOGLE_STORE]: { src: logoGoogleplayFr, width: 135, height: 40 }
  }
}
